import { DatePipe } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogClose,
  MatDialogRef,
} from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PayeeButtonComponent } from '../../payee-buttons/payee-button/payee-button.component';
import { PayeePopupComponent } from '../../payee-popup/payee-popup.component';
import { CivilLawsuitContact } from '../types';

export type CivilLawsuitContactDialogData = {
  contact: CivilLawsuitContact;
  payee_case_reference_id: string;
  debtor_name: string;
};

@Component({
  selector: 'payee-civil-lawsuit-contact-dialog',
  templateUrl: './civil-lawsuit-contact-dialog.component.html',
  styleUrls: ['./civil-lawsuit-contact-dialog.component.scss'],
  imports: [
    PayeePopupComponent,
    PayeeButtonComponent,
    MatDialogClose,
    TranslateModule,
  ],
  providers: [DatePipe],
})
export class CivilLawsuitContactDialogComponent {
  private dialogRef =
    inject<MatDialogRef<CivilLawsuitContactDialogComponent>>(MatDialogRef);
  private datePipe = inject(DatePipe);
  private translate = inject(TranslateService);
  readonly data = inject<CivilLawsuitContactDialogData>(MAT_DIALOG_DATA);

  readonly introKey = computed(() =>
    this.data.contact.dispute_is_full
      ? 'CASES_TABLE.CIVIL_LAWSUIT_DIALOG.INTRO_FULL'
      : 'CASES_TABLE.CIVIL_LAWSUIT_DIALOG.INTRO_PARTIAL',
  );

  readonly instructionsKey = computed(() =>
    this.data.contact.dispute_is_full
      ? 'CASES_TABLE.CIVIL_LAWSUIT_DIALOG.INSTRUCTIONS_FULL'
      : 'CASES_TABLE.CIVIL_LAWSUIT_DIALOG.INSTRUCTIONS_PARTIAL',
  );

  readonly instructionsParams = computed(() => ({
    deadline: this.formatFilingDeadline(this.data.contact.filing_deadline_at),
  }));

  onClose = (): void => {
    this.dialogRef.close();
  };

  private formatFilingDeadline(isoDate: string | null): string {
    if (!isoDate) {
      return '';
    }

    const locale = this.translate.currentLang || this.translate.defaultLang || 'hu';

    return (
      this.datePipe.transform(
        isoDate,
        'yyyy. MM. dd.',
        'Europe/Budapest',
        locale,
      ) ?? ''
    );
  }
}
